// TextContent.jsx
import React, { useState } from "react";
import style from "./TextContent.module.css";

// Import your image
import image1 from "./assets/short banner of size - 1200X350.jpg";
import Header from "../../../Components/Header/Header";

const TextContent = () => {
  const [readMore, setReadMore] = useState(false);

  const handleReadMore = () => {
    setReadMore((r) => !r);
  };

  return (
    <>
      <Header />
      <div className={style.TextContent}>
        <div className={style.carouselWrapper}>
          <h1 className={style.mainHeading}>
            Dasara Mahotsav 2025 – Annadan Seva at Kanaka Durga Temple, Vijayawada
          </h1>

          {/* Static banner (single image) */}
          <div className={style.carouselInner}>
            <div className={style.slide}>
              <img
                src={image1}
                alt="Dasara Mahotsav banner"
                className={style.carouselImg}
              />
            </div>
          </div>
        </div>

        <p className={style.patagContent}>
          During the sacred Dasara Mahotsav at Sri Durga Malleswara Swamy Varla
          Devasthanam, famously known as the Kanaka Durga Temple in Vijayawada,
          lakhs of devotees gather to seek the blessings of Goddess Kanaka Durga.
          From 22 September to 2 October 2025, ISKCON Vijayawada is blessed to
          serve the pilgrims through a grand Annadan Seva, distributing free
          prasadam every single day to tens of thousands of visitors climbing
          Indrakeeladri Hill for darshan.
        </p>

        <div
          className={`${style.collapsible} ${readMore ? style.open : ""}`}
          aria-hidden={!readMore}
        >
          <p className={style.patagContent}>
            Annadan, the offering of food, is regarded as the highest form of
            charity in Sanatana Dharma. Feeding devotees during their pilgrimage
            to Kanaka Durga Temple is considered equal to serving the Goddess
            herself. Through this seva, ISKCON Vijayawada is ensuring that every
            pilgrim not only receives sanctified prasadam but also departs with
            blessings, nourishment, and spiritual satisfaction.
            <br />
            <br />
            Throughout the eleven days of Dasara Mahotsav, ISKCON’s kitchens will
            prepare and distribute prasadam including rice, pulihora, pongal,
            daddojanam, sweets, and other traditional offerings. Special
            significance is given to Moola Nakshatra on 29 September and
            Vijayadashami on 2 October, when an extraordinary scale of prasadam
            distribution is planned, with lakhs of laddus and maha annadan
            arrangements made to serve the massive gathering of devotees.
            <br />
            <br />
            The Annadan Seva is conducted under ISKCON’s globally renowned Food
            for Life initiative, which guarantees that food is prepared with
            utmost purity, cleanliness, and devotion, following sustainable and
            eco-friendly practices. Every meal becomes prasadam, food sanctified
            by the blessings of the Lord, and offered with love to all pilgrims
            without discrimination.
            <br />
            <br />
            Supporters and well-wishers are invited to take part in this noble
            initiative. By contributing to Annadan Seva during Dasara Mahotsav,
            you are directly serving Goddess Kanaka Durga’s devotees. You can
            sponsor prasadam for a day, support the ongoing distribution,
            volunteer your time, or simply spread the word of this divine seva.
            Each act of service multiplies the blessings received by thousands of
            devotees who depend on this sacred food distribution during the
            festival.
            <br />
            <br />
            The Annadan Seva venue is located at Sri Durga Malleswara Swamy Varla
            Devasthanam, Kanaka Durga Temple, Vijayawada, Andhra Pradesh,
            organized by ISKCON Vijayawada from its temple headquarters, Sri Sri
            Radha Shyamsundar Mandir.
            <br />
            <br />
            Join ISKCON Vijayawada in this sacred Dasara seva and be part of
            feeding tens of thousands of devotees during Dasara Mahotsav 2025.
            Experience the joy of giving, receive the blessings of Goddess Kanaka
            Durga, and take part in one of the most spiritually uplifting
            services of this festive season.
          </p>
        </div>

        <button
          className={`${style.readMoreBtn} ${readMore ? style.active : ""}`}
          onClick={handleReadMore}
        >
          {readMore ? "Read Less" : "Read More"}
        </button>
      </div>
    </>
  );
};

export default TextContent;
